
import React from "react";
import { useTranslation } from "react-i18next";
import { Page, Layout, SearchFilter } from "@tiendanube/components";

import { navegateExit } from "../../libs/nexo/helpers";
import nexo from "../../nexoClient";
import ProductListEmpty from "./components/ProductListEmpty";
import ProductResults from "./components/ProductResults";
import useProducts from "./useProducts";

function ProductListPage() {
    const { t } = useTranslation();

    const {
        prods,
        filter,
        showSkeletons,
        showEmptyList,
        showEmptySearch,
        showFooter,
        showError,
        refetch,
        loadMoreProducts,
        applyFilter,
        removeFilter
    } = useProducts();

    const handleBack = () => {
        navegateExit(nexo);
    }

    if (showEmptyList) {
        return (
            <Page headerNavigation={{ onClick: handleBack }} title={t('productList.title')}>
                <ProductListEmpty />
            </Page>
        );
    }

    const appliedFilters = filter ? [{
        id: "search",
        label: filter
    }] : [];

    const handleSubmit = (value: string) => {
        applyFilter(value);
    };
    const handleDismiss = () => {
        removeFilter();
    };

    return (

        <Page headerNavigation={{ onClick: handleBack }}
            title={t('productList.title')}
            subtitle={t('productList.subTitle')}>
                <Layout>
                <Layout.Section>
                        <SearchFilter
                            placeholder={t('productFilter.placeHolder')}
                            appliedFilters={appliedFilters}
                            onSubmit={handleSubmit}
                            onDismiss={handleDismiss}
                        />
                        <ProductResults
                            prods={prods}
                            showEmptySearch={showEmptySearch}
                            showSkeletons={showSkeletons}
                            showError={showError}
                            showFooter={showFooter}
                            refetch={refetch}
                            loadMoreProducts={loadMoreProducts}
                        />
                    </Layout.Section>
                </Layout>
            </Page>

    );
}

export default ProductListPage;
